import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInAppClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M4.5 4.5L13.5 13.5M4.5 13.5L13.5 4.5",
			strokeWidth: 2.0625,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#878D96"
		})
	})
});
export default SvgInAppClose;
